export const NAME = 'core-auth';
export const LOGOUT_ERROR_MESSAGE = "Error clearing token from localStorage: ";
